import axios from 'axios';

const axios_instance = axios.create({
  baseURL: `https://${import.meta.env.VITE_AUTH0_DOMAIN}`,
});

export default axios_instance;
